import api from "../lib/api";

export type PublicJoinRole = "Advocate" | "Party in Person";
export type IdentityType = "Aadhaar" | "Voter" | "PAN" | "Passport" | "DL";

export interface PublicJoinContextPayload {
  meetingId: string;
  mobile: string;
  caseNumber: string;
}

export interface PublicJoinProfilePayload extends PublicJoinContextPayload {
  firstName: string;
  lastName: string;
  email: string;
  role: PublicJoinRole;
  enrollment?: string;
  identityType?: IdentityType;
  identityNumber?: string;

  meetingId: string;
  mobile: string;
  caseNumber: string;
}

export const checkPublicMeetingJoinApi = (payload: PublicJoinContextPayload) =>
  api.post("/api/public-meeting/check", payload);

export const resendPublicMeetingJoinOtpApi = (
  payload: PublicJoinContextPayload,
) => api.post("/api/public-meeting/resend-otp", payload);

export const verifyPublicMeetingJoinOtpApi = (
  payload: PublicJoinContextPayload & { otp: string },
) => api.post("/api/public-meeting/verify-otp", payload);

export const registerPublicMeetingJoinApi = (
  payload: PublicJoinProfilePayload,
) => api.post("/api/public-meeting/register", payload);

export const getPublicPrejoinContextApi = (token: string) =>
  api.get(`/api/public-meeting/prejoin/${encodeURIComponent(token)}`);

export const getPublicPrejoinCasesApi = (payload: any = {}) =>
  api.post(`/api/public-meeting/cases`, payload);

export const getPublicPrejoinCaseInfoApi = ({
  caseNo,
  enrollment,
}: {
  caseNo: string;
  enrollment: string | undefined;
}) => api.post(`/api/public-meeting/case-info`, { caseNo, enrollment });

export const getPublicPrejoinMeetingsApi = (payload: any = {}) =>
  api.post(`/api/public-meeting/meetings`, payload);

export const getPublicStreamsApi = (payload: any = {}) =>
  api.post(`/api/public-meeting/streams`, payload);
